import script from "./PrinPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrinPage.vue?vue&type=script&lang=ts&setup=true"

import "./PrinPage.vue?vue&type=style&index=0&id=055d35b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055d35b1"]])

export default __exports__